export const environment = {
  production: true,
  API_URL: 'http://corpora.lancs.ac.uk/',
  API_BASE_URL: 'http://corpora.lancs.ac.uk:8080/api/',
  SOCKET_URL: 'http://corpora.lancs.ac.uk:8080/'
};




// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/environments/environment.ts